import { createRef } from 'react'
import _ from 'lodash'
import clx from 'classnames'
import { Icon, Loader } from '@vzmi/shp_shared_compo'
import refreshIcon from '@vzmi/svg-icons-ec/icons/refresh-alt'
import styles from './SalesPerformance.css'
import safeAwait from '../../../../../lib/safeAwait'
import SPBaseModule from '../../../../lib/SPBaseModule'
import Tabs from '../../../Common/NewDashboard/Tabs/Tabs'
import { DATE_FORMAT, getDashboardDateTime } from '../../../../lib/MomentHelper'
import { dollarFormat, numeralFormat } from '../../../../../lib/renderUtil'
import CommonTable from '../../../Common/NewDashboard/Table/Table'
import { withI13nWrapper } from '../../../Common/I13nWrapper'
import { flexAlignCenter } from '../../../../styles/shared.css'

const TAB = {
  PERF_TABLE: 'perf_table',
  ACCU_TABLE: 'perf_accu_table'
}

const TAB_MAP = {
  [TAB.PERF_TABLE]: '即時業績',
  [TAB.ACCU_TABLE]: '累積業績'
}

const FIELD = {
  REPORTDATE: 'reportDate',
  AMOUNT: 'amount',
  QUANTITY: 'quantity'
}

const FIELD_MAP = {
  [FIELD.REPORTDATE]: '時段',
  [FIELD.AMOUNT]: '訂購金額',
  [FIELD.QUANTITY]: '訂購量'
}

class SalesPerformance extends SPBaseModule {
  constructor (props) {
    super(props)
    this.state = {
      performance: [],
      selectedTab: TAB.PERF_TABLE
    }
    this.dialog = createRef()
  }

  componentDidMount () {
    this.onSearch()
    this.props.i13nMethods.sendI13nPageViewByPageKey('hourlysale_mobile')
  }

  onTabChange = tabKey => {
    this.setState({ selectedTab: tabKey })
  }

  onSearch = () => this.loading(async () => {
    const { fetchSalesPerformances } = this.props
    const [reqError, resp] = await safeAwait(
      fetchSalesPerformances()
    )
    const error = reqError || resp.error
    if (error) {
      this.setIsError(true)
      this.setIsLoading(false)
      return
    }

    const {
      statistics = []
    } = _.get(resp, 'payload', {})
    this.setState({ performance: statistics })
    this.setIsSuccess(true)
  })

  render () {
    const {
      performance,
      isLoading,
      isError,
      selectedTab
    } = this.state
    return (
      <Loader loaded={!isLoading}>
        <BackToPCLink />
        {
          isError
            ? this.renderIOError()
            : (
              <Tabs
                activeKey={selectedTab}
                onChange={this.onTabChange}
                className={styles.tabs}
                items={[
                  {
                    label: TAB_MAP[TAB.PERF_TABLE],
                    key: TAB.PERF_TABLE,
                    children: (
                      <div className={styles.tableBlock}>
                        <Table
                          data={_.cloneDeep(performance).reverse()}
                          onSearch={this.onSearch}
                        />
                      </div>
                    )
                  },
                  {
                    label: TAB_MAP[TAB.ACCU_TABLE],
                    key: TAB.ACCU_TABLE,
                    children: (
                      <div className={styles.tableBlock}>
                        <Table
                          data={accuData(performance)}
                          isAccuData
                          onSearch={this.onSearch}
                        />
                      </div>
                    )
                  }
                ]}
              />
            )
        }
      </Loader>
    )
  }
}

const BackToPCLink = () => (
  <a
    href="/dashboard?pc=1#salesPerformance"
    className={styles.backToPCLink}
  >
    回電腦版
  </a>
)

const RefreshIcon = props => {
  const {
    iconColor = '#5478fc',
    className
  } = props
  return (
    <Icon
      asset={refreshIcon}
      color={iconColor}
      className={className}
      onClick={props.onSearch}
    />
  )
}

const Table = props => {
  return (
    <CommonTable
      sortable={false}
      resizable={false}
      showPagination={false}
      data={props.data}
      columns={columns(props)}
      className={styles.resultTable}
      pageSize={24}
      {...props}
    />
  )
}

const columns = props => {
  const { isAccuData, data } = props
  const accuStartTime = data.length > 0 && _.last(data)[FIELD.REPORTDATE]

  return [{
    id: FIELD.REPORTDATE,
    accessor: FIELD.REPORTDATE,
    width: 'auto',
    className: clx(flexAlignCenter),
    Header: (<>
      {FIELD_MAP[FIELD.REPORTDATE]}
      <RefreshIcon {...props} />
    </>),
    Cell: row => (
      <>
        {getDashboardDateTime(
          isAccuData ? accuStartTime : row.value,
          DATE_FORMAT.DASHBOARD
        )}
        <span>~</span>
        {getDashboardDateTime(row.value, 'MM/DD HH:59')}
      </>
    )
  },
  {
    id: FIELD.AMOUNT,
    accessor: FIELD.AMOUNT,
    width: 'auto',
    className: clx(flexAlignCenter),
    Header: FIELD_MAP[FIELD.AMOUNT],
    Cell: row => dollarFormat(_.toNumber(row.value))
  },
  {
    id: FIELD.QUANTITY,
    accessor: FIELD.QUANTITY,
    width: 'auto',
    Header: FIELD_MAP[FIELD.QUANTITY],
    className: clx(flexAlignCenter, styles.col),
    Cell: row => numeralFormat(row.value, { allowZero: true })
  }]
}

const accuData = (data) =>
  _.slice(
    data.reduce((previousValue, currentValue) => {
      const lastItem = _.last(previousValue)
      previousValue.push(
        {
          ...currentValue,
          [FIELD.AMOUNT]: _.toNumber(currentValue[FIELD.AMOUNT]) + lastItem[FIELD.AMOUNT],
          [FIELD.QUANTITY]: currentValue[FIELD.QUANTITY] + lastItem[FIELD.QUANTITY]
        }
      )
      return previousValue
    }, [{
      [FIELD.AMOUNT]: 0,
      [FIELD.QUANTITY]: 0
    }])
    , 1).reverse()

export default withI13nWrapper(SalesPerformance)
